import { render, staticRenderFns } from "./message_input.vue?vue&type=template&id=501a5add&scoped=true&"
import script from "./message_input.vue?vue&type=script&lang=ts&"
export * from "./message_input.vue?vue&type=script&lang=ts&"
import style0 from "./message_input.vue?vue&type=style&index=0&id=501a5add&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "501a5add",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VBtn,VIcon,VTextarea})
